import { apiClient as api } from "./httpClient";

/**
 * Pagos não realizados (RN-215, item 146): sessões que o paciente pagou e que não aconteceram.
 * "Aconteceu" é ter presença "Compareceu"; o resto — falta, cancelamento ou presença nunca
 * marcada — é dinheiro recebido sem atendimento prestado.
 */
export interface PaidNotAttendedRow {
  scheduleId: string;
  start: string;
  end: string;
  patientId: string;
  patientName: string;
  serviceName: string;
  specialtyName: string;
  professionalName: string;
  confirmation: string;
  presence: string;
  paymentDate: string | null;
  value: number;
  /** Nulo quando a baixa foi na própria agenda: não há recibo a abrir. */
  paymentId: string | null;
}

export interface PaidNotAttendedOption {
  id: string;
  name: string;
}

export interface PaidNotAttendedGroup {
  name: string;
  count: number;
  total: number;
}

export interface PaidNotAttendedReport {
  from: string;
  to: string;
  count: number;
  total: number;
  withoutPresenceCount: number;
  withoutPresenceTotal: number;
  byPresence: PaidNotAttendedGroup[];
  byConfirmation: PaidNotAttendedGroup[];
  items: PaidNotAttendedRow[];
  professionals: PaidNotAttendedOption[];
  specialties: PaidNotAttendedOption[];
  presences: PaidNotAttendedOption[];
  confirmations: PaidNotAttendedOption[];
}

export interface PaidNotAttendedFilters {
  from?: string;
  to?: string;
  patientId?: string;
  professionalId?: string;
  professionalTypeId?: string;
  presence?: string;
  confirmation?: string;
}

const query = (filters: PaidNotAttendedFilters): string => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([chave, valor]) => {
    if (valor) params.append(chave, valor);
  });
  const texto = params.toString();
  return texto ? `?${texto}` : "";
};

export const paidNotAttendedService = {
  get: async (filters: PaidNotAttendedFilters): Promise<PaidNotAttendedReport> => {
    const response = await api.get(`/reports/paid-not-attended${query(filters)}`, { timeout: 60000 });
    return response.data;
  },

  exportXlsx: async (filters: PaidNotAttendedFilters): Promise<Blob> => {
    const response = await api.get(`/reports/paid-not-attended/export${query(filters)}`, {
      responseType: "blob",
      timeout: 60000,
    });
    return response.data;
  },
};
